import { render, staticRenderFns } from "./loadMore.vue?vue&type=template&id=08fb44f9&scoped=true"
import script from "./loadMore.vue?vue&type=script&lang=js"
export * from "./loadMore.vue?vue&type=script&lang=js"
import style0 from "./loadMore.vue?vue&type=style&index=0&id=08fb44f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fb44f9",
  null
  
)

export default component.exports